import { message } from 'ant-design-vue';
import { useUserStore } from '@/store/user';
import type { AddOrderData } from '@/views/power/service';
import { createCorporateOrder, commitCorporateOrder, CORPORATE_PAYMENT_ERROR, type CorporatePaymentResult } from '@/services/corporatePayment';
import { beginCorporateOrder } from './session';
import type { TeamCorporateState } from './types';

/** 团队三种对公场景共用成功边界；旧响应不得写回或调用成功回调。 */
export async function submitTeamCorporateOrder(state: TeamCorporateState, params: AddOrderData, success?: (result: CorporatePaymentResult) => void) {
  const isHostOpen = state.modalOpen || state.productModalIsOpen || state.teamMemberPayModalOpen;
  if (state.corporateOrderLoading || state.isUseCorporateTransfer || !isHostOpen) return;
  const session = beginCorporateOrder(state);
  try {
    const result = await session.wait(createCorporateOrder(params, session.signal));
    if (!session.isActive()) return;
    if (session.isTimedOut()) throw new Error(CORPORATE_PAYMENT_ERROR);
    session.finish();
    commitCorporateOrder(state, result);
    success?.(result);
    return result;
  } catch (error) {
    if (session.isActive()) {
      state.scanPaymentError = true;
      handleCorporateError(error);
    }
  } finally {
    session.finish();
  }
}

function handleCorporateError(error: unknown) {
  if (typeof error === 'object' && error !== null && 'code' in error && error.code === 80000) {
    void useUserStore().queryUserInfo();
    message.warn('当前账号已加入团队');
  } else {
    message.error(CORPORATE_PAYMENT_ERROR);
  }
}
